import React, { useState, useEffect } from 'react';
import firebaseGetImageUrl from '../../helpers/firebaseGetImageUrl';
import styles from './style.module.css';

function Product({ data = {} }) {
  const [image, setImage] = useState("")

  const loadImage = async () => {
    const img = await firebaseGetImageUrl(data?.photos[0], 512, 1);
    if (img)
      setImage(img)
  }

  const Price = () => {
    return (parseFloat(data.price) * ((100 - parseFloat(data.discount)) / 100)) || 0;
  }


  useEffect(() => {
    loadImage()
    console.log(data)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <div className={styles.container}>
    <img
      className={styles.image}
      src={image}
      alt=" " />
    <div className={"mt-2 mb-2"}>
      <p className={styles.header}>{data?.category}</p>
      <p className={styles.category}>{data?.subCategory}</p>
      {/* <a href={`/p/${data?.uid}`}><p className={styles.profile}>Profile</p></a> */}
    </div>
    <div className={styles.priceContainer}>
      <a className="btn btn-primary" href={`/edit/products/${data.pid}`}>Open</a>
      <div />
      <div>
        <p className={styles.price}>{`${Price().toFixed(2)} GEL`}</p>
        {data.discount !== 0 && <p className={styles.discount}>{`${data.price} GEL`}</p>}
      </div>
    </div>
  </div>
}

export default Product;
